<template>
	<v-card :flat="flat">
		<v-card-title>
			<span>Forms</span>
			<v-spacer></v-spacer>
			<v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details class="mb-0"></v-text-field>
			<v-btn color="primary" class="ml-3" @click="$emit('createForm')">Create Form</v-btn>
		</v-card-title>

		<v-data-table
			disable-initial-sort
			:headers="headers"
			:items="forms"
			:pagination.sync="pagination"
			:rows-per-page-items="rowsPerPageItems"
			:search="search"
			:loading="isLoading"
		>
			<template slot="items" slot-scope="props">
				<tr>
					<td class="text-xs-left">{{ props.item.name || 'Untitled form' }}</td>
					<td class="text-xs-left">{{ props.item.description || 'No description provided.' }}</td>
					<td class="text-xs-left">v{{ props.item.currentVersionNo }}</td>
					<td class="text-xs-left">
						<v-chip small label :color="getStatusColor(props.item.status)" :dark="getStatusColor(props.item.status) !== ''">{{ props.item.status }}</v-chip>
					</td>
					<td class="text-xs-left">
						<AppDate :date="props.item.lastUpdatedDateUtc || props.item.createdDateUtc" />
					</td>
					<td class="text-xs-right">
						<v-btn small flat color="primary" @click="$emit('editForm', props.item)">Edit</v-btn>
					</td>
				</tr>
			</template>
			<template slot="no-data">
				<div class="text--secondary pa-3">No forms have been created yet.</div>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	export default {
		name: 'FormsList',
		props: {
			forms: {
				type: Array,
				default: () => []
			},
			isLoading: {
				type: Boolean,
				default: false
			},
			flat: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				search: '',
				pagination: {
					sortBy: 'name',
					descending: false,
					rowsPerPage: 12
				},
				rowsPerPageItems: [12, 30, 60, { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }]
			};
		},
		computed: {
			headers() {
				return [
					{ text: 'Name', value: 'name' },
					{ text: 'Description', value: 'description' },
					{ text: 'Version', value: 'currentVersionNo' },
					{ text: 'Status', value: 'status' },
					{ text: 'Updated', value: 'lastUpdatedDateUtc' },
					{ text: '', value: 'actions', sortable: false, align: 'right' }
				];
			}
		},
		methods: {
			getStatusColor(status) {
				switch (status) {
					case 'Active':
						return 'success';
					case 'Archived':
						return 'warning';
					case 'Deleted':
						return 'error';
					default:
						return '';
				}
			}
		}
	};
</script>
